import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components/macro';

import { useTracking } from '../../data/gtm';
import { uiColors } from '../../common/styles';
import { useAuth, useComposition, useFrami, useImages, useNavigation, useCompositionTemplates } from '../../context';
import { Api, Toastify } from '../../utilities';
import { logError } from '../../utilities/logError';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    background: ${(props) => (props.$isDragActive ? uiColors.PRIMARY_200 : '')};
`;

const WallBackgroundDropzone = ({ noClick, style, children }) => {
    const { setWallBackgrounds } = useFrami();
    const { setUploadProgress } = useImages();

    const onDrop = useCallback(async (acceptedFiles) => {
        if (acceptedFiles.length === 0) return;

        const uploadedBackgrounds = [];
        setUploadProgress(0);

        for (let i = 0; i < acceptedFiles.length; i++) {
            const file = acceptedFiles[i];
            const formData = new FormData();
            formData.append("file", file);
            formData.append("name", file.name);

            try {
                const response = await Api.post("/shopify/svg/walls/", formData, {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    },
                });

                uploadedBackgrounds.push(response);
            } catch (err) {
                logError(err);
                Toastify.error(err.response?.data ?? err.message);
            }
        }
        setWallBackgrounds((prev) => [...prev, ...uploadedBackgrounds]);
        setUploadProgress(null);

    }, []);

    const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
        accept: { "image/*": [".png", ".jpg", ".jpeg", ".webp"] },
        noClick: noClick,
        noKeyboard: true,
        onDrop,
    });

    return (
        <Wrapper {...getRootProps()} $isDragActive={isDragActive} style={style}>
            <input {...getInputProps()} />
            {typeof children === 'function' ? children(open) : children}
        </Wrapper>
    );
};

export default WallBackgroundDropzone;
